import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'
import { ConfigurationPreformattedResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import PreformattedEditor from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor/preformatted-editor.vue'
import { preformattedMacroServices } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted-macro.service'

@Component({
    components: {
        PreformattedEditor
    }
})
export default class LocalPreformattedModalMacro extends Vue {
    @Prop() readonly selectedRow!: Nullable<ConfigurationPreformattedResponse>
    @Prop() readonly broadcastChannelPostMessageFunction!: Function

    get preformattedId(): number {
        return this.selectedRow?.id!
    }

    get laboratoryId(): number {
        return this.selectedRow?.laboratory?.labId!
    }

    get actionTitle(): string {
        return this.$t('configuration.modal.preformated.macroscopy').toString()
    }

    get service(): typeof preformattedMacroServices {
        return preformattedMacroServices
    }
}
